export default {
	// Config
	apiKey: "AIzaSyDy3RMj7OdmdGgDBWMxQkHuMhl_Zcfa6lw",
  authDomain: "binske-mytrace.firebaseapp.com",
  projectId: "binske-mytrace",
  storageBucket: "binske-mytrace.firebasestorage.app",
  messagingSenderId: "851266859487",
  appId: "1:851266859487:web:0eeae48a0ca5cdac72d46a"
};
